<template>
  <v-container style="max-width: 1800px">
    <v-card class="ma-0">
      <v-toolbar color="primary" dark>
        Usuários 
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
          
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: "users-card",
  props: [
    "users",
 
  ],

  components: {},

  data() {
    return {
     
    }
  },

  computed: {
    },

  async mounted() {

  },

  watch: {

  },
  methods: {
     
  },
};
</script>

<style scoped>

</style>